import { useQuery } from "@tanstack/react-query";
import { gamificationApi } from "../api/gamificationApi";

export function useBadges(courseId?: string) {
  return useQuery({
    queryKey: ["badges", courseId],
    queryFn: () => gamificationApi.getBadges(courseId),
  });
}

export function useEarnedBadges() {
  return useQuery({
    queryKey: ["earned-badges"],
    queryFn: () => gamificationApi.getEarnedBadges(),
  });
}

export function useCourseMilestones(courseId: string) {
  return useQuery({
    queryKey: ["milestones", courseId],
    queryFn: () => gamificationApi.getCourseMilestones(courseId),
    enabled: !!courseId,
  });
}

export function useGamificationSummary() {
  return useQuery({
    queryKey: ["gamification-summary"],
    queryFn: () => gamificationApi.getSummary(),
  });
}
